import { render, staticRenderFns } from "./IndexBranch.vue?vue&type=template&id=2a640222&scoped=true&"
import script from "./IndexBranch.vue?vue&type=script&lang=js&"
export * from "./IndexBranch.vue?vue&type=script&lang=js&"
import style0 from "./IndexBranch.vue?vue&type=style&index=0&id=2a640222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a640222",
  null
  
)

export default component.exports